import analytics from "../services/analytics";
import notification from "../services/notification";

export default {
    namespaced: true,
    state: {
        loading: false,
        branchPerformance: [],
        branchPerformancePagination: {
            maxPage: 1,
            nextPage: 0,
            prevPage: 0,
            currentPage: 1,
            totalPerPage: 1,
            currentFirstItem: 1,
            currentLastItem: 1,
            initialPageCount: 0
        },
        branchFilter: [],
        visitTierType: [],
        skuPerformance: [],
        skuPerformancePagination: {
            maxPage: 1,
            nextPage: 0,
            prevPage: 0,
            currentPage: 1,
            totalPerPage: 1,
            currentFirstItem: 1,
            currentLastItem: 1,
            initialPageCount: 0
        },
        branchRegistrationCount: [],
        branchRegistrationCountPagination: {
            maxPage: 1,
            nextPage: 0,
            prevPage: 0,
            currentPage: 1,
            totalPerPage: 1,
            currentFirstItem: 1,
            currentLastItem: 1,
            initialPageCount: 0
        },
        topCustomerVisit: [],
        customerGender: [],
        ageGroupRegistrations: [],
        topSpendingVisitor: [],
        snack: {
            amount: 0,
            count: 0,
            avg_per_table: 0
        },
        breakfast: {
            amount: 0,
            count: 0,
            avg_per_table: 0
        },
        dinner: {
            amount: 0,
            count: 0,
            avg_per_table: 0
        },
        lunch: {
            amount: 0,
            count: 0,
            avg_per_table: 0
        },
        lateDinner: {
            amount: 0,
            count: 0,
            avg_per_table: 0
        },
        maxPage: 1,
        nextPage: 0,
        prevPage: 0,
        currentPage: 1,
        totalPerPage: 1,
        currentFirstItem: 1,
        currentLastItem: 1,
        initialPageCount: 0,
        inquiro: null,
        isSegmentAnalyticsReady: !!(process.env.VUE_APP_SEGMENT_API_KEY &&
            window.analytics &&
            typeof window.analytics.load === "function"),
    },
    mutations: {
        loading(state, value = true) {
            state.loading = value;
        },
        branchPerformance(state, branchPerformance) {
            state.branchPerformance = branchPerformance;
            state.loading = false;
            state.searching = false;
        },
        branchPerformancePagination(state, branchPerformancePagination) {
            state.branchPerformancePagination.totalPerPage = branchPerformancePagination.list.length;
            state.branchPerformancePagination.maxPage = branchPerformancePagination.max_page;
            state.branchPerformancePagination.prevPage = branchPerformancePagination.prev_page;
            state.branchPerformancePagination.nextPage = branchPerformancePagination.next_page;
            state.branchPerformancePagination.currentPage = state.branchPerformancePagination.prevPage + 1;
            state.branchPerformancePagination.currentFirstItem =
                state.branchPerformancePagination.initialPageCount * state.branchPerformancePagination.prevPage + 1;
            state.branchPerformancePagination.currentLastItem =
                state.branchPerformancePagination.currentFirstItem > 0
                    ? state.branchPerformancePagination.currentFirstItem + state.branchPerformancePagination.totalPerPage - 1
                    : 0;
        },
        setBranchPerformanceInitialPageCount(state, list) {
            state.branchPerformancePagination.initialPageCount = list.length;
        },
        pagination(state, pagination) {
            state.totalPerPage = pagination.list.length;
            state.maxPage = pagination.max_page;
            state.prevPage = pagination.prev_page;
            state.nextPage = pagination.next_page;
            state.currentPage = state.prevPage + 1;
            state.currentFirstItem =
                state.initialPageCount * state.prevPage + 1;
            state.currentLastItem =
                state.currentFirstItem > 0
                    ? state.currentFirstItem + state.totalPerPage - 1
                    : 0;
        },
        branchFilter(state, branchFilter) {
            state.branchFilter = branchFilter;
        },
        visitTierType(state, visitTierType) {
            state.visitTierType = visitTierType;
        },
        skuPerformance(state, skuPerformance) {
            state.skuPerformance = skuPerformance;
            state.loading = false;
            state.searching = false;
        },
        skuPerformancePagination(state, skuPerformancePagination) {
            state.skuPerformancePagination.totalPerPage = skuPerformancePagination.list.length;
            state.skuPerformancePagination.maxPage = skuPerformancePagination.max_page;
            state.skuPerformancePagination.prevPage = skuPerformancePagination.prev_page;
            state.skuPerformancePagination.nextPage = skuPerformancePagination.next_page;
            state.skuPerformancePagination.currentPage = state.skuPerformancePagination.prevPage + 1;
            state.skuPerformancePagination.currentFirstItem =
                state.skuPerformancePagination.initialPageCount * state.skuPerformancePagination.prevPage + 1;
            state.skuPerformancePagination.currentLastItem =
                state.skuPerformancePagination.currentFirstItem > 0
                    ? state.skuPerformancePagination.currentFirstItem + state.skuPerformancePagination.totalPerPage - 1
                    : 0;
        },
        setSKUPerformanceInitialPageCount(state, list) {
            state.skuPerformancePagination.initialPageCount = list.length;
        },
        branchRegistrationCount(state, branchRegistrationCount) {
            state.branchRegistrationCount = branchRegistrationCount;
            state.loading = false;
            state.searching = false;
        },
        branchRegistrationCountPagination(state, branchRegistrationCountPagination) {
            state.branchRegistrationCountPagination.totalPerPage = branchRegistrationCountPagination.list.length;
            state.branchRegistrationCountPagination.maxPage = branchRegistrationCountPagination.max_page;
            state.branchRegistrationCountPagination.prevPage = branchRegistrationCountPagination.prev_page;
            state.branchRegistrationCountPagination.nextPage = branchRegistrationCountPagination.next_page;
            state.branchRegistrationCountPagination.currentPage = state.branchRegistrationCountPagination.prevPage + 1;
            state.branchRegistrationCountPagination.currentFirstItem =
                state.branchRegistrationCountPagination.initialPageCount * state.branchRegistrationCountPagination.prevPage + 1;
            state.branchRegistrationCountPagination.currentLastItem =
                state.branchRegistrationCountPagination.currentFirstItem > 0
                    ? state.branchRegistrationCountPagination.currentFirstItem + state.branchRegistrationCountPagination.totalPerPage - 1
                    : 0;
        },
        setBranchRegistrationCountInitialPageCount(state, list) {
            state.branchRegistrationCountPagination.initialPageCount = list.length;
        },
        topCustomerVisit(state, topCustomerVisit) {
            state.topCustomerVisit = topCustomerVisit;
        },
        customerGender(state, customerGender) {
            state.customerGender = customerGender;
        },
        ageGroupRegistrations(state, ageGroupRegistrations) {
            state.ageGroupRegistrations = ageGroupRegistrations;
        },
        topSpendingVisitor(state, topSpendingVisitor) {
            state.topSpendingVisitor = topSpendingVisitor;
        },
        snack(state, snack) {
            state.snack = snack;
        },
        breakfast(state, breakfast) {
            state.breakfast = breakfast;
        },
        dinner(state, dinner) {
            state.dinner = dinner;
        },
        lunch(state, lunch) {
            state.lunch = lunch;
        },
        lateDinner(state, lateDinner) {
            state.lateDinner = lateDinner;
        },
        errors(state, errors) {
            state.errors = errors;
            state.loading = false;
        },
        setInquiro(state, value) {
            state.inquiro = value;
        }
    },
    actions: {
        async getBranchPerformance({ commit }, param) {
            commit("loading");
            let racksAndTenyaBranchCodes = [
                { brand: 'Tenya', code: 'T001', branch_name: 'Tenya Megamall' },
                { brand: 'Tenya', code: 'T002', branch_name: 'Tenya BGC' },
                { brand: 'Tenya', code: 'T003', branch_name: 'Tenya Market Market' },
                { brand: 'Tenya', code: 'T004', branch_name: 'Tenya SM Southmall' },
                { brand: 'Tenya', code: 'T005', branch_name: 'Tenya Aseana' },
                { brand: 'Tenya', code: 'T006', branch_name: 'Tenya Festival' },
                { brand: 'Tenya', code: 'T007', branch_name: 'Tenya SM Mall of Asia' },
                { brand: 'Tenya', code: 'T008', branch_name: 'Tenya Magallanes' },
                { brand: 'Tenya', code: 'T009', branch_name: 'Tenya Tiendesitas' },
                { brand: 'Racks', code: 'P001', branch_name: 'Racks EL Pueblo' },
                { brand: 'Racks', code: 'P002', branch_name: 'Racks Greenhills' },
                { brand: 'Racks', code: 'P010', branch_name: 'Racks Santa Rosa' },
                { brand: 'Racks', code: 'P003', branch_name: 'Racks Magallanes' },
                { brand: 'Racks', code: 'P004', branch_name: 'Racks SM MOA' },
                { brand: 'Racks', code: 'P005', branch_name: 'Racks Festival' },
                { brand: 'Racks', code: 'P006', branch_name: 'Racks SM Megammal' },
                { brand: 'Racks', code: 'P007', branch_name: 'Racks SM North EDSA' },
                { brand: 'Racks', code: 'P008', branch_name: 'Racks Robinsons' },
                { brand: 'Racks', code: 'P011', branch_name: 'Racks SM Pampanga' },
                { brand: 'Racks', code: 'P012', branch_name: 'Racks SM Southmall' },
                { brand: 'Racks', code: 'P014', branch_name: 'Racks The Fort' },
                { brand: 'Racks', code: 'P015', branch_name: 'Racks Trinoma' },
                { brand: 'Racks', code: 'P016', branch_name: 'Racks Timog' },
                { brand: 'Racks', code: 'P017', branch_name: 'Racks Evia' },
                { brand: 'Racks', code: 'P018', branch_name: 'Racks SM Cebu' },
                { brand: 'Racks', code: 'P019', branch_name: 'Racks Aseana' },
                { brand: 'Racks', code: 'P020', branch_name: 'Racks Uptown' },
                { brand: 'Racks', code: 'P021', branch_name: 'Rackshack Circuit' },
                { brand: 'Racks', code: 'P022', branch_name: 'Rackshack SM Aura' },
                { brand: 'Racks', code: 'P023', branch_name: 'Racks Tiendisitas' }
            ];

            try {

                let response = await analytics.getBranchPerformance(param);

                if (param.page == 1) {
                    await commit("setBranchPerformanceInitialPageCount", response.list);
                }

                for (let index = 0; index < response.list.length; index++) {
                    let branchCode = response.list[index].branch_code;
                    let result = racksAndTenyaBranchCodes.find( ({ code }) => code === branchCode);
                    response.list[index].branch_name = result != undefined ? result.branch_name : null;
                }

                await commit("branchPerformance", response.list);
                await commit("branchPerformancePagination", response);
                commit("loading", false);
            } catch (errors) {
                commit("errors", errors);
                commit("loading", false);
            }
        },
        async getVisitTierType({ commit }, param) {
            commit("loading");

            try {

                let response = await analytics.getVisitTierType(param);
                
                if (response.length > 0) {
                    let visitTierType = [response[1], response[2], response[0]];
                    await commit("visitTierType", visitTierType);
                } else {
                    await commit("visitTierType", []);
                }
                
                commit("loading", false);
            } catch (errors) {
                commit("errors", errors);
                commit("loading", false);
            }
        },
        getBranchFilter({ commit }, merchantUuid) {
            let branchFilter = [];
            if (merchantUuid == 'aa1c538b-df7e-4654-be6e-d7e6f5977d53') {
                branchFilter = [
                    { value: '', text: 'All Branches' },
                    { value: 'P002', text: 'Racks Greenhills', uuid: '200f189f-5ddb-4dc2-8a53-bb4dc718d95f' },
                    { value: 'P010', text: 'Racks Santa Rosa', uuid: '716552a0-f5f5-48fe-bdfa-f0338837c48f' },
                    { value: 'P003', text: 'Racks Magallanes', uuid: '6af72d84-a578-4666-91e3-3b3152582229' },
                    { value: 'P004', text: 'Racks SM MOA', uuid: '927c5d04-971c-45b8-b0c4-094215688973' },
                    { value: 'P005', text: 'Racks Festival', uuid: '250597dd-998e-46c1-b24a-780181cfc587' },
                    { value: 'P006', text: 'Racks SM Megamall', uuid: '80123331-f6c0-477d-b8c5-6b8e20125dde' },
                    { value: 'P007', text: 'Racks SM North EDSA', uuid: 'b14ef22f-f715-4ee1-959a-92e761fe57e2' },
                    { value: 'P008', text: 'Racks Robinsons', uuid: 'e7ec280e-4669-4eba-a7a8-365d9a7f4723' },
                    { value: 'P011', text: 'Racks SM Pampanga', uuid: '9e20c85f-bebb-4fd4-8a6c-06957126dcf5' },
                    { value: 'P012', text: 'Racks SM Southmall', uuid: '249a80b9-6e01-4e6f-989e-deeec31c4d37' },
                    { value: 'P014', text: 'Racks The Fort', uuid: 'ddb4ff64-3d46-429f-a8d7-7141a894cd12' },
                    { value: 'P015', text: 'Racks Trinoma', uuid: '5a4f08b6-507b-4d8f-a038-5bdb4c64dfb0' },
                    { value: 'P016', text: 'Racks Timog', uuid: '63f435b9-9b69-488b-89ce-7965225f70fd' },
                    { value: 'P017', text: 'Racks Evia', uuid: 'a9ccd9b9-460e-4e96-bd0c-38df0f7b0848' },
                    { value: 'P018', text: 'Racks SM Cebu', uuid: 'e8a26197-4f04-4564-b002-6007b0af6de8' },
                    { value: 'P019', text: 'Racks Aseana', uuid: '136f3a8e-60d8-413f-af51-97cdba8a6db8' },
                    { value: 'P020', text: 'Racks Uptown', uuid: '096f3ced-1576-400e-92a9-0515345382dc' },
                    { value: 'P023', text: 'Racks Tiendisitas', uuid: 'de5dd00f-71c1-4d62-a895-2166f799ff8f' },
                    { value: 'no-branch', text: 'No Branch', uuid: 'no-branch' }
                ];
            } else if (merchantUuid == '6e277127-5e4b-48aa-a15c-0e1757d3a5a2') {
                branchFilter = [
                    { value: '', text: 'All Branches' },
                    { value: 'T001', text: 'Tenya Megamall', uuid: '07a383c7-079e-4e01-9d2c-7a3eef75c241' },
                    { value: 'T002', text: 'Tenya BGC', uuid: 'b5ac3066-0558-4c7e-94a3-4a03aa64b830' },
                    { value: 'T003', text: 'Tenya Market Market', uuid: '335de9e9-1ac7-4e91-b799-54b01cb18dd7' },
                    { value: 'T004', text: 'Tenya SM Southmall', uuid: 'd2afd5cc-80ba-4176-90a4-1e30ee1879ec' },
                    { value: 'T005', text: 'Tenya Aseana', uuid: 'f820847f-119f-448c-b0a4-800c325bea75' },
                    { value: 'T006', text: 'Tenya Festival', uuid: 'bd63ced5-b303-4834-81f2-903b0538635d' },
                    { value: 'T007', text: 'Tenya SM Mall of Asia', uuid: '5b82459d-d9c6-4fd2-9d35-675242d8c229' },
                    { value: 'T008', text: 'Tenya Magallanes', uuid: '9e79ab14-007b-426c-82a9-85c35b8d2f1c' },
                    { value: 'T009', text: 'Tenya Tiendesitas', uuid: 'af294455-d3ca-4c60-ac7b-3d987747ac82' },
                    { value: 'no-branch', text: 'No Branch', uuid: 'no-branch' }
                ];
            }
            
            commit("branchFilter", branchFilter);
        },
        async getSKUPerformance({ commit }, param) {

            commit("loading");

            try {
                let response = await analytics.getSKUPerformance(param);

                if (param.page == 1) {
                    await commit("setSKUPerformanceInitialPageCount", response.list);
                }
                await commit("skuPerformance", response.list);
                await commit("skuPerformancePagination", response);
                commit("loading", false);
            } catch (errors) {
                commit("errors", errors);
                commit("loading", false);
            }
        },
        async getTopCustomerVisit({ commit }, param) {
            commit("loading");

            try {

                let response = await analytics.getTopCustomerVisit(param);

                await commit("topCustomerVisit", response.list);
                commit("loading", false);
            } catch (errors) {
                commit("errors", errors);
                commit("loading", false);
            }
        },
        async getBranchRegistrationCount({ commit }, param) {

            commit("loading");

            try {
                let response = await analytics.getBranchRegistrationCount(param);

                if (param.page == 1) {
                    await commit("setBranchRegistrationCountInitialPageCount", response.list);
                }

                await commit("branchRegistrationCount", response.list);
                await commit("branchRegistrationCountPagination", response);
                commit("loading", false);
            } catch (errors) {
                commit("errors", errors);
                commit("loading", false);
            }
        },
        async getCustomerGender({ commit }, param) {
            commit("loading");

            try {

                let response = await analytics.getCustomerGender(param);

                let customerGender = [];

                customerGender.push({gender: 'Male', registration_count: response.list["male"] });
                customerGender.push({gender: 'Female', registration_count: response.list["female"] });
                customerGender.push({gender: 'Blank', registration_count: response.list["blank"] });

                if (response.list["male"] == null && response.list["female"] == null && response.list["blank"] == null) {
                    await commit("customerGender", []);
                } else {
                    // customerGender.push(response.list);
                    await commit("customerGender", customerGender);
                }

                commit("loading", false);
            } catch (errors) {
                commit("errors", errors);
                commit("loading", false);
            }
        },
        async getAgeGroupRegistrations({ commit }, param) {

            commit("loading");

            try {
                let response = await analytics.getAgeGroupRegistrations(param);
                await commit("ageGroupRegistrations", response.list);
                commit("loading", false);
            } catch (errors) {
                commit("errors", errors);
                commit("loading", false);
            }
        },
        async getTopSpendingVisitor({ commit }, param) {

            commit("loading");

            try {
                let response = await analytics.getTopSpendingVisitor(param);

                await commit("topSpendingVisitor", response.list);
                commit("loading", false);
            } catch (errors) {
                commit("errors", errors);
                commit("loading", false);
            }
        },
        async getDayPartReport({ commit }, param) {

            commit("loading");

            try {
                let response = await analytics.getDayPartReport(param);

                if (response.SNACK != undefined) {
                    commit("snack", response.SNACK);
                } else {
                    commit("snack", {
                        amount: 0,
                        count: 0,
                        avg_per_table: 0
                    })
                }

                if (response.DINNER != undefined) {
                    commit("dinner", response.DINNER);
                } else {
                    commit("dinner", {
                        amount: 0,
                        count: 0,
                        avg_per_table: 0
                    })
                }

                if (response.LUNCH != undefined) {
                    commit("lunch", response.LUNCH);
                } else {
                    commit("lunch", {
                        amount: 0,
                        count: 0,
                        avg_per_table: 0
                    })
                }

                if (response.LATE_DINNER != undefined) {
                    commit("lateDinner", response.LATE_DINNER);
                } else {
                    commit("lateDinner", {
                        amount: 0,
                        count: 0,
                        avg_per_table: 0
                    })
                }

                if (response.BREAKFAST != undefined) {
                    commit("breakfast", response.BREAKFAST);
                } else {
                    commit("breakfast", {
                        amount: 0,
                        count: 0,
                        avg_per_table: 0
                    })
                }

                commit("loading", false);
            } catch (errors) {
                commit("errors", errors);
                commit("loading", false);
            }
        },
        async getInquiro({ commit }) {
            commit("loading");

            try {
                const response = await analytics.getInquiro();                
                commit("setInquiro", response.result);
            } catch (errors) {
                commit("setInquiro", null);
                commit("errors", errors);
            } finally {
                commit("loading", false);
            }
        },
    }
};
